import React from 'react';
import { Button } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { ROUTE_CLINIC_CLEAR_COOKIES, ROUTE_HOME } from '../constants/routes';
import { strings } from '../constants/localization';
import dentiLogo from '../resources/images/denti-logo-2.png';
import sundhedLogo from '../resources/images/sundhedplus-logo-invert.svg';
import ErrorDataCard from './ErrorDataCard';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null, errorInfo: null };

  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    console.log({ error, errorInfo });
    this.setState({
      error,
      errorInfo,
    });
  }
  componentDidMount() {
    document.body.id = process.env.REACT_APP_BRAND;
  }

  render() {
    const { serverErrorDetails } = this.props;
    if (this.state.hasError) {
      return (
        <div className='error-page'>
          <div className='error-boundary-wrapper'>
            <div className='error-canvas'>
              <div className='error-container'>
                <div className='error-content'>
                  <div className='something-went-wrong'>
                    <h1>{strings.errorBoundaryTitle}</h1>
                    <Button
                      type='button'
                      className='btn btn-blue mt-2 mb-4'
                      href={ROUTE_CLINIC_CLEAR_COOKIES}
                    >
                      {strings.errorBoundaryText}
                    </Button>

                    {/* More tehnical information section */}
                    <div className='panel active'>
                      <details>
                        <summary>Click to see JavaScript error details</summary>
                        <p>
                          <strong>{this.state.error?.toString()}</strong>
                        </p>
                        <pre>{this.state.errorInfo?.componentStack}</pre>
                      </details>
                    </div>

                    {serverErrorDetails?.data && (
                      <div className='panel active'>
                        <details>
                          <summary>Click to see failed API Calls</summary>
                          <ErrorDataCard />
                        </details>
                      </div>
                    )}

                    <div className='panel active'>
                      <details>
                        <summary>Click to see additional page details</summary>
                        <div style={{ width: '100%', height: '500px' }}>
                          <iframe
                            src='/status.html'
                            title='Client page details'
                            width='100%'
                            height='100%'
                            style={{ border: 'none' }}
                          />
                        </div>
                      </details>
                    </div>
                  </div>
                </div>
                <NavLink to={ROUTE_HOME} className='public-page-logo'>
                  {process.env.REACT_APP_BRAND === 'Denti' && (
                    <img className='brandLogo' src={dentiLogo} alt='Denti' />
                  )}
                  {process.env.REACT_APP_BRAND === 'Sundhedplus' && (
                    <img
                      className='sundhedLogo'
                      src={sundhedLogo}
                      alt='Sundhed+'
                    />
                  )}
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const mapStateToProps = (state) => ({
  serverErrorDetails: state?.ui?.serverErrorDetails,
});

export default connect(mapStateToProps)(ErrorBoundary);
